import { useCallback } from 'react';
import useLocalStorage from './useLocalStorage';

/**
 * Hook to manage onboarding state
 * Tracks whether user has completed onboarding
 */
export default function useOnboarding() {
  const [onboardingState, setOnboardingState] = useLocalStorage(
    'onboardingCompleted',
    {
      completed: false,
      completedDate: null,
    }
  );

  // useCallback so consumers can safely put this in a useEffect dep array -
  // a plain arrow function here is a new reference every render, which (as
  // a real bug in MainPage.jsx confirmed live) re-arms any timer/effect
  // that depends on it every time the component re-renders, not just when
  // onboarding completion actually changes.
  const hasCompletedOnboarding = useCallback(
    () => onboardingState.completed,
    [onboardingState.completed]
  );

  const completeOnboarding = useCallback(() => {
    setOnboardingState({
      completed: true,
      completedDate: new Date().toISOString(),
    });
  }, [setOnboardingState]);

  const skipOnboarding = useCallback(() => {
    setOnboardingState({
      completed: true,
      completedDate: new Date().toISOString(),
      skipped: true,
    });
  }, [setOnboardingState]);

  return {
    hasCompletedOnboarding,
    completeOnboarding,
    skipOnboarding,
  };
}
